import React, { FC } from 'react';
import { SelectInput, SelectOption } from '../inputs';
import { formatMessage } from '@/utils/i18n';

interface Props {
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}

export const MINIMUM_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [MINIMUM_PAGE_SIZE, 50, 75, 100];

const PaginationPageSizeDropdown: FC<Props> = ({ pageSize, setPageSize }) => (
  <SelectInput
    onValueChange={value => setPageSize(value)}
    selected={pageSize}
    upwards
    className="pagination-page-size-dropdown select-input-v2 slim"
    aria-label={formatMessage('Pagination.SelectPageSize')}
  >
    {PAGE_SIZE_OPTIONS.map(option => (
      <SelectOption key={option} value={option} aria-label={formatMessage('Pagination.PageSizeOptionAccessible', { pageSize: option })}>
        {formatMessage('Pagination.PageSizeOption', { pageSize: option })}
      </SelectOption>
    ))}
  </SelectInput>
);

export default PaginationPageSizeDropdown;
